/**
 * An add-on listed from its stored record alone is missing the fields only the
 * catalog supplies. There are two reasons for that, and they need different
 * words: the catalog could not be loaded, which resolves on its own, or the
 * catalog loaded and does not list this add-on, which will not.
 */
const LAUNCH_CATALOG_UNAVAILABLE =
  'The add-on catalog could not be loaded, so there is no route to open this add-on. It will work again once the catalog loads.';
const LAUNCH_NOT_IN_CATALOG =
  'This add-on is not listed in the current add-on catalog, so there is no route to open it.';

const INSTALL_CATALOG_UNAVAILABLE =
  'The add-on catalog could not be loaded, so the chart to install from is unknown. It will be installable again once the catalog loads.';
const INSTALL_NOT_IN_CATALOG =
  'This add-on is not listed in the current add-on catalog, so the chart to install from is unknown.';

export function launchBlockedMessage(catalogUnavailable: boolean) {
  return catalogUnavailable
    ? LAUNCH_CATALOG_UNAVAILABLE
    : LAUNCH_NOT_IN_CATALOG;
}

export function installBlockedMessage(catalogUnavailable: boolean) {
  return catalogUnavailable
    ? INSTALL_CATALOG_UNAVAILABLE
    : INSTALL_NOT_IN_CATALOG;
}
